export type ReadonlyWatchedListEndpoints = {
    readonly Watch: string;
    readonly Unwatch: string;
    readonly isWatching: string;
    readonly IsWatchingBulk?: string;
  };

  const controller = 'api/Watchlist'

  const WatchedListEndpoints: ReadonlyWatchedListEndpoints = {
    Watch: `${controller}/watch`,
    Unwatch: `${controller}/unwatch`,
    isWatching:`${controller}/IsWatching`,
    IsWatchingBulk: `${controller}/IsWatchingBulk`
  };
  
  export { WatchedListEndpoints };